import { Box, Flex } from 'components/elements'
import {
  IconButtonCss,
  ImageCss,
  ShimmerCss,
  Tags1Css,
  Tags2Css,
  TagsNumberCss,
  TextShimmer,
} from '.'
import { AvatarShimmer } from './avatar'

export const RolesAndPermissionShimmer = () => {
  return (
    <Flex css={{ width: '100%' }} direction={'column'}>
      <Flex justify={'between'} css={{ height: 51, mb: '$space$20' }}>
        <AvatarShimmer
          // showToggle={true}
          showIcon={true}
          iconStyle="rounded"
          iconSize="md"
        />
        <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
      </Flex>
      <Flex css={{ height: 40, m: 0, mb: '$space$20' }}>
        <TextShimmer />
      </Flex>
      <Flex align={'center'} wrap="wrap" css={{ height: 64, mb: '$space$24' }}>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
        <Box css={{ ...ShimmerCss, ...TagsNumberCss }}></Box>
      </Flex>
      <Flex>
        {Array.from({ length: 5 }).map((_, i) => (
          <Box
            key={i}
            css={{
              ...ShimmerCss,
              ...ImageCss,
              borderRadius: '50%',
              ...(i > 0 && { ml: '-$space$5' }),
            }}
          />
        ))}
      </Flex>
    </Flex>
  )
}
